import DataStorage from '../_utils/DataStorage';

const CARDS_PER_PAGE = 20;
const TRANSITION_DURATION = 1000;

export default class InvestmentList {


	// Constructor
	constructor(element) {

		var i;
		var l;


		////////////////////

		// Get Elements

		this.investmentLabel = element.querySelector('.investment-label')
		this.investmentLabelKeys = {
			all: this.investmentLabel.dataset.historicLabel,
		}

		this.categorySelect = element.querySelector('.section-investments--sectors select');
		this.categorySelectText = element.querySelector('.section-investments--sectors span');

		this.involvementSelect = element.querySelector('.section-investments--involvement select');
		this.involvementSelectText = element.querySelector('.section-investments--involvement span');

		this.sortSelect = element.querySelector('.section-investments--sort select');
		this.sortSelectText = element.querySelector('.section-investments--sort span');

		this.investmentLinks = element.querySelector('[data-investment-link]')

		this.filterIsEnabled = false;
		if (this.categorySelect && this.involvementSelect && this.sortSelect) {
			this.filterIsEnabled = true;
			this.categorySelect.addEventListener('change', this.categorySelectChange.bind(this));
			this.involvementSelect.addEventListener('change', this.involvementSelectChange.bind(this));
			this.sortSelect.addEventListener('change', this.sortSelectChange.bind(this));
		}

		this.updateCards = this.updateCards.bind(this);
		this.cardContainer = element.querySelector('.section-investments--cards');
		this.cards = Array.prototype.slice.call(element.querySelectorAll('.card-investment'), 0);

		this.noResults = element.querySelector('.section-investments--no-results');

		this.moreButtonContainer = element.querySelector('.section-investments--button');
		this.moreIsEnabled = false;
		this.visibleCards = CARDS_PER_PAGE;
		if (this.moreButtonContainer) {
			this.moreIsEnabled = true;
			this.moreButtonContainer.querySelector('button').addEventListener('click', this.moreButtonClick.bind(this));
		}

		////////////////////

		// Get Select Options

		if (this.filterIsEnabled) {

			this.categoryValues = {};
			if (this.categorySelect) {
				for (i=0, l=this.categorySelect.options.length; i<l; i++) {
					this.categoryValues[ this.categorySelect.options[i].value ] = this.categorySelect.options[i].text;
				}
			}

			this.involvementValues = { 'all': 'All' };
			if (this.involvementSelect) {
				for (i=0, l=this.involvementSelect.options.length; i<l; i++) {
					this.involvementValues[ this.involvementSelect.options[i].value ] = this.involvementSelect.options[i].text;
				}
			}


			this.sortValues = {};
			if (this.sortSelect) {
				for (i=0, l=this.sortSelect.options.length; i<l; i++) {
					this.sortValues[ this.sortSelect.options[i].value ] = this.sortSelect.options[i].text;
				}
			}
		}

		////////////////////

		// Get Initial Values

		this.valCat = 'all';
		this.valInv = 'current';
		this.valSort = 'name-az';
		this.valGoTo = null;

		let prevInvolvement, prevSort, prevCat, prevGoTo;

		this.urlParams = new URLSearchParams(window.location.search);
		if (this.urlParams) {
			prevInvolvement = this.urlParams.get('involvement');

			if (prevInvolvement && this.involvementValues[prevInvolvement]) {
				this.valInv = prevInvolvement;
				this.updateTitle()
			}

			prevSort = this.urlParams.get('sort');
			if (prevSort && this.sortValues[prevSort]) {
				this.prevSort = prevSort;
			}

			prevCat = this.urlParams.get('category');
			if (prevCat && this.categoryValues[prevCat]) {
				this.valCat = prevCat;
			}

			prevGoTo = this.urlParams.get('goto');
			if (prevGoTo) {
				this.valGoTo = prevGoTo;
			}
		}

		if (this.filterIsEnabled) {

			// Don't override the involvement value from the url
			if (!prevInvolvement) {
				// prevInvolvement = DataStorage.getSessionItem('investment-list-involvement');
				if (prevInvolvement && this.involvementValues[prevInvolvement]) {
					this.valInv = prevInvolvement;
				}
			}

			// const prevCat = DataStorage.getSessionItem('investment-list-category');
			if (prevCat && this.categoryValues[prevCat]) {
				this.valCat = prevCat;
			}

			// const prevSort = DataStorage.getSessionItem('investment-list-sort');
			if (prevSort && this.sortValues[prevSort]) {
				this.valSort = prevSort;
			}

			const visibleCards = DataStorage.getSessionItem('investment-list-cards');
			if (visibleCards) {
				this.visibleCards = visibleCards;
			}
		}

		////////////////////

		// Misc Vars

		this.isFirst = true;
		this.timer = null;

		////////////////////

		// Initial Update

		this.updateFields();
	}


	// Update
	updateFields(forceUpdate) {

		clearTimeout(this.timer);

		if (this.moreIsEnabled === false) {
			this.visibleCards = this.cards.length;
		}

		if (this.filterIsEnabled) {

			this.categorySelect.value = this.valCat;
			this.categorySelectText.innerHTML = this.categoryValues[this.valCat];
			this.involvementSelect.value = this.valInv;
			this.involvementSelectText.innerHTML = this.involvementValues[this.valInv];
			this.sortSelect.value = this.valSort;
			this.sortSelectText.innerHTML = this.sortValues[this.valSort];

			this.urlParams.set('involvement', this.valInv)
			this.urlParams.set('sort', this.valSort)
			this.urlParams.set('category', this.valCat)
			this.urlParams.delete('goto')

			if (!this.isFirst) {
				window.history.pushState({}, '', `${location.pathname}?${this.urlParams.toString()}`)
			}

			// DataStorage.setSessionItem('investment-list-sort', this.valSort);
			// DataStorage.setSessionItem('investment-list-involvement', this.valInv);
			// DataStorage.setSessionItem('investment-list-category', this.valCat);
			DataStorage.setSessionItem('investment-list-cards', this.visibleCards);

			this.cards.forEach((card) => {
				let link = card.querySelector('[data-investment-link]')
				let url = link.dataset.investmentLink
				url = `${url}?${encodeURIComponent(this.urlParams.toString())}`
				link.setAttribute('href', url)
			})
		}

		this.updateTitle()

		if (forceUpdate || this.isFirst) {
			this.isFirst = false;
			this.updateCards();
		} else {
			this.cardContainer.classList.add('fade-out');
			this.noResults.classList.add('fade-out');
			this.timer = setTimeout(this.updateCards, TRANSITION_DURATION);
		}

	}
	updateCards(loadMore) {
		clearTimeout(this.timer);

		const container = this.cardContainer;
		const cat = this.valCat;
		const inv = this.valInv;

		let totalCards = 0;
		let visibleCards = this.visibleCards;

		if (loadMore !== true) {
			this.cards.forEach(function(card){
				if (card.parentNode) {
					card.parentNode.removeChild(card);
				}
			});
		}

		if (this.filterIsEnabled) {
			if (loadMore !== true) {
				const dataKey = 'data-name';
				const dir = (this.valSort === 'name-za') ? -1 : 1;

				this.cards.sort(function(a, b) {
					// Name sorting fields
					const v1 = a.getAttribute(dataKey).toLowerCase();
					const v2 = b.getAttribute(dataKey).toLowerCase();

					const involvement1 = a.getAttribute('data-involvement').toLowerCase();
					const involvement2 = b.getAttribute('data-involvement').toLowerCase();

					if (v1 < v2) {
						return -1 * dir;
					}
					if (v1 > v2) {
						return 1 * dir;
					}
					return 0;
				});

				const involvement = this.valInv
				const involvementDirection = this.valInv.toLowerCase() === 'current' ? -1 : 1

				this.cards.sort(function(a, b) {
					const inv1 = a.getAttribute('data-involvement').toLowerCase() == 'current' ? 2 : 1;
					const inv2 = b.getAttribute('data-involvement').toLowerCase() == 'current' ? 2 : 1;

					if (inv1 < inv2) {
						return -1 * involvementDirection;
					}

					if (inv1 > inv2) {
						return 1 * involvementDirection;
					}

					return 0;
				})
			}

			this.cards.forEach(function(card){
				const cats = card.getAttribute('data-categories').split('|');
				const exit = card.getAttribute('data-date-exit');
				const selectedInvestment = card.getAttribute('data-selected-investment') === 'true';

				if (cat === 'all' || cats.indexOf(cat) > -1) {
					if (totalCards < visibleCards) {
						if (!card.parentNode) {
							container.appendChild(card);
						}
					}
					totalCards += 1;
				}
			});
		} else {
			this.cards.forEach(function(card){
				if (totalCards < visibleCards) {
					if (!card.parentNode) {
						container.appendChild(card);
					}
				}
				totalCards += 1;
			});
		}

		if (totalCards === 0) {
			this.noResults.classList.add('show');
		} else {
			this.noResults.classList.remove('show');
		}

		if (this.moreButtonContainer) {
			if (visibleCards < totalCards) {
				this.moreButtonContainer.classList.remove('hide');
			} else {
				this.moreButtonContainer.classList.add('hide');
			}
		}

		window.dispatchEvent(new Event('resize'));
		this.cardContainer.classList.remove('fade-out');
		this.noResults.classList.remove('fade-out');

		if (this.valGoTo) {
			const scrollTo = document.getElementById('investment-' + this.valGoTo);
			if (scrollTo) {
				const y = scrollTo.getBoundingClientRect().top + window.pageYOffset - 100;
				window.scroll(0, y);
			}
		}
		this.valGoTo = null;

	}

	updateTitle() {
		if (this.investmentLabelKeys[this.valInv]) {
			this.investmentLabel.textContent = this.investmentLabelKeys[this.valInv]
			return;
		}

		this.investmentLabel.textContent = this.investmentLabel.dataset.defaultLabel
	}

	// Event Handlers
	categorySelectChange(event) {
		this.valCat = event.currentTarget.value;
		this.visibleCards = CARDS_PER_PAGE;
		this.updateFields();
	}
	involvementSelectChange(event) {
		this.valInv = event.currentTarget.value;
		this.visibleCards = CARDS_PER_PAGE;
		this.updateFields();
	}
	sortSelectChange(event) {
		this.valSort = event.currentTarget.value;
		this.visibleCards = CARDS_PER_PAGE;
		this.updateFields();
	}
	moreButtonClick(event) {
		event.preventDefault();
		event.currentTarget.blur();
		this.visibleCards += CARDS_PER_PAGE;
		this.updateFields()
		this.updateCards(true);
	}
}
